import React from 'react';

export default function UserIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-user' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
